import MoveWorkflowToStepById from 'ia-react-core/~/actions/workflow/MoveWorkflowToStepById';
import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import { WorkflowState } from 'ia-react-core/~/interfaces/WorkflowState';
import workflowMovedToStepById from '../../../actions/workflow-fn/workflowMovedToStepById';

export default function workflowReducer(state: WorkflowState, action: CoreAction) {
  const { workflowId } = state;

  switch (action.type) {
    case `${workflowMovedToStepById.type}/${workflowId}`:
      return reduceMoveToStep(state, action as MoveWorkflowToStepById);
    default:
      return state;
  }
}

function reduceMoveToStep(state: WorkflowState, { stepName }: MoveWorkflowToStepById) {
  return {
    ...state,
    currentStepName: stepName,
  };
}
